"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FoxCustomDialog = _interopRequireDefault(require("fox-react/dist/components/FoxCustomDialog"));

var _redux = require("redux");

var _reduxForm = require("redux-form");

var _formValidators = require("fox-react/dist/utils/formValidators");

var _Form = _interopRequireDefault(require("fox-react/dist/components/Form"));

var _FoxDateTimePickerField = _interopRequireDefault(require("fox-react/dist/reduxFormFields/FoxDateTimePickerField"));

var _FoxInputTextareaField = _interopRequireDefault(require("fox-react/dist/reduxFormFields/FoxInputTextareaField"));

var _FoxInputTextField = _interopRequireDefault(require("fox-react/dist/reduxFormFields/FoxInputTextField"));

var _FoxUploadFiles = _interopRequireDefault(require("fox-react/dist/components/FoxUploadFiles"));

var _DeliveredDialogModule = _interopRequireDefault(require("./DeliveredDialog.module.scss"));

var _Attachment = _interopRequireDefault(require("../commons/Attachment"));

var _IconArea = _interopRequireDefault(require("../commons/IconArea"));

var _icons = _interopRequireDefault(require("../commons/FontAwesomeIcon/icons"));

var _languageService = _interopRequireDefault(require("../../language/services/languageService"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  uploadAttachments: _propTypes.default.func.isRequired,
  attachments: _propTypes.default.array.isRequired
};

function AttachmentFieldArray(_ref) {
  var fields = _ref.fields,
      attachments = _ref.attachments;
  return _react.default.createElement("div", null, fields.map(function (member, index) {
    return _react.default.createElement(_Attachment.default, {
      key: attachments[index].id,
      fileName: attachments[index].name,
      onRemove: function onRemove() {
        return fields.remove(index);
      }
    });
  }));
}

AttachmentFieldArray.propTypes = {
  fields: _propTypes.default.object.isRequired,
  attachments: _propTypes.default.array.isRequired
};

function DeliveredDialog(_ref2) {
  var isOpen = _ref2.isOpen,
      onCloseClick = _ref2.onCloseClick,
      handleSubmit = _ref2.handleSubmit,
      uploadAttachments = _ref2.uploadAttachments,
      attachments = _ref2.attachments;
  return _react.default.createElement(_FoxCustomDialog.default, {
    title: _languageService.default.labels.RealizedDetails(),
    isOpen: isOpen,
    onCloseClick: onCloseClick,
    style: {
      minWidth: '650px'
    },
    noLabel: _languageService.default.labels.Cancel(),
    yesLabel: _languageService.default.buttons.Realized(),
    onConfirmClick: handleSubmit,
    bigger: true
  }, _react.default.createElement(_Form.default, {
    handleSubmit: handleSubmit
  }, _react.default.createElement("div", {
    className: _DeliveredDialogModule.default.row
  }, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.unfilledClock,
    iconTitle: _languageService.default.labels.DeliveryDate(),
    alignTop: true,
    iconClassName: _DeliveredDialogModule.default.icon
  }, _react.default.createElement("div", {
    className: _DeliveredDialogModule.default.row_small
  }, _react.default.createElement(_FoxDateTimePickerField.default, {
    label: _languageService.default.labels.DeliveryDate(),
    name: "deliveryDate",
    required: true
  })))), _react.default.createElement("div", {
    className: _DeliveredDialogModule.default.row
  }, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.comment,
    iconTitle: _languageService.default.labels.Comment(),
    iconClassName: _DeliveredDialogModule.default.icon,
    alignTop: true
  }, _react.default.createElement(_FoxInputTextField.default, {
    name: "invoiceNumber",
    label: _languageService.default.labels.InvoiceNumber()
  }))), _react.default.createElement("div", {
    className: _DeliveredDialogModule.default.row
  }, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.comment,
    iconTitle: _languageService.default.labels.Attachments(),
    iconClassName: _DeliveredDialogModule.default.icon,
    alignTop: true
  }, _react.default.createElement("label", null, _languageService.default.labels.Attachments()), _react.default.createElement(_FoxUploadFiles.default, {
    name: "attachments",
    label: _languageService.default.labels.Attachments(),
    multiple: true,
    batch: false,
    onAdd: uploadAttachments,
    className: _DeliveredDialogModule.default.uploadFiles
  }), _react.default.createElement(_reduxForm.FieldArray, {
    name: "attachments",
    component: AttachmentFieldArray,
    attachments: attachments
  }))), _react.default.createElement("div", {
    className: _DeliveredDialogModule.default.row
  }, _react.default.createElement(_IconArea.default, {
    icon: _icons.default.comment,
    iconTitle: _languageService.default.labels.Comment(),
    iconClassName: _DeliveredDialogModule.default.icon,
    alignTop: true
  }, _react.default.createElement(_FoxInputTextareaField.default, {
    name: "message",
    label: _languageService.default.labels.Comment()
  })))));
}

DeliveredDialog.propTypes = propTypes;

var validate = function validate(values) {
  var errors = {};
  (0, _formValidators.isRequired)(errors, values, 'deliveryDate', _languageService.default.validationMessages.FieldRequired());
  (0, _formValidators.isRequired)(errors, values, 'invoiceNumber', _languageService.default.validationMessages.FieldRequired());
  return errors;
};

var _default = (0, _redux.compose)((0, _reduxForm.reduxForm)({
  form: 'deliveredDialog',
  enableReinitialize: true,
  validate: validate
}), _react.memo, (0, _reduxForm.formValues)('attachments'))(DeliveredDialog);

exports.default = _default;